import { ApiError, type SignInChallenge } from './api'

/**
 * What the second step asks for: an address, for an on-premises owner that has
 * none yet (a code is then sent there), or else the code already sent.
 */
export function stepAsks(challenge: SignInChallenge): 'email' | 'code' {
  return challenge.needsEmail ? 'email' : 'code'
}

/**
 * The address step again, from the code step it led to: a mistyped address is
 * put right on the same challenge, whose tries carry over.
 */
export function backToAddress(challenge: SignInChallenge): SignInChallenge {
  return { challenge: challenge.challenge, method: challenge.method, needsEmail: true, expiresIn: challenge.expiresIn }
}

const ENDS_STEP =new Set(['CODE_EXPIRED', 'CODE_LOCKED', 'CODE_UNAVAILABLE', 'TOO_MANY_ADDRESSES', 'TOO_MANY_ATTEMPTS'])

/**
 * Whether a refusal of the emailed code ends the code step, so the sign-in
 * screen goes back to the password. An ended challenge (CODE_EXPIRED) takes no
 * more codes, and a locked one (CODE_LOCKED) takes none for a quarter of an
 * hour: left on the code field, the person would keep typing into a step that
 * can only refuse. A wrong code (CODE_REFUSED) keeps it — the same challenge
 * takes another try. An address step past its limits (TOO_MANY_ADDRESSES,
 * TOO_MANY_ATTEMPTS) has ended too, and so has one whose code the relay would
 * not take (CODE_UNAVAILABLE): the server ends that challenge.
 */
export function endsCodeStep(err: unknown): boolean {
  return err instanceof ApiError && ENDS_STEP.has(err.code)
}
